import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-from-bottom-icon',
  templateUrl: './navigation-arrow-from-bottom.component.html'
})
export class NavigationArrowFromBottomComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
